import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "px-4 py-3 border-t border-gray-200 bg-gray-50" };
const _hoisted_2 = { class: "flex items-start gap-3 p-3 bg-white border border-gray-200 rounded-xl" };
const _hoisted_3 = { class: "flex-shrink-0 mt-0.5" };
const _hoisted_4 = { class: "text-sm font-medium text-gray-700" };
const _hoisted_5 = { class: "text-xs text-gray-500 mt-0.5" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { IconLock } from "@tabler/icons-vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ClosedBanner',
    props: {
        reason: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const normalizedReason = computed(() => ["USER_CLOSED", "INACTIVITY_TIMEOUT", "REFERENCE_INVALIDATED"].includes(String(props.reason))
            ? String(props.reason)
            : "DEFAULT");
        const banner = computed(() => ({
            title: t(`conversation.closed_banner.${normalizedReason.value}.title`),
            body: t(`conversation.closed_banner.${normalizedReason.value}.body`),
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(IconLock), { class: "w-4 h-4 text-gray-400" })
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_4, _toDisplayString(banner.value.title), 1),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(banner.value.body), 1)
                    ])
                ])
            ]));
        };
    }
});
